module.exports = __webpack_public_path__ + "static/img/sb.ae0321c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCenter/sb.png
// module id = FNqv
// module chunks = 0